<template>
  <div>
    <a-table class="home-table" :columns="columns" :data-source="data" bordered>
    </a-table>
  </div>
</template>
<script>
import { mainTablelInfo } from "@/api/homeApi.js";
const columns = [
  {
    title: "日前",
    dataIndex: "date",
    slots: { customRender: "name" },
  },
  {
    title: "总用户",
    className: "column-money",
    dataIndex: "usersTotal",
  },
  {
    title: "周活跃度",
    dataIndex: "weeklyActivity",
  },
  {
    title: "月活跃度",
    dataIndex: "monthlyActivity",
  },
  {
    title: "月沉默",
    dataIndex: "silence",
  },
  {
    title: "月沉默率",
    dataIndex: "silenceRate",
  },
];
export default {
  data() {
    return {
      data: [],
      columns,
    };
  },

  mounted() {
    this.getMainTablelInfo();
  },
  methods: {
    getMainTablelInfo() {
      mainTablelInfo(1, 1).then((res) => {
        this.data = res.data;
      });
    },
  },
};
</script>
<style scoped>
.home-table {
  padding: 15px;
  background-color: #ffff;
  height: 567px;
  overflow: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/home/homeTable.vue